import React from 'react'
import { compose, pure } from 'recompose'
import styles from './darkContentSectionComponent.scss'
import ContentContainer from '../contentContainer/contentContainerComponent'
import PropTypes from 'prop-types'
export function DarkContentSection (props: Props) {
  return (
    <div className={[styles.darkSectionContainer, props.className].join(' ')}>
      <ContentContainer>
        {props.children}
      </ContentContainer>
    </div>
  )
}
DarkContentSection.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
}

export default compose(pure)(DarkContentSection)



// WEBPACK FOOTER //
// ./src/components/darkContentSection/darkContentSectionComponent.js